function SchemaAnnotater(isFlat) {
  this._isFlat = !!isFlat;
  this._annotations = { properties: {} };
}

module.exports = {
  createSchemaAnnotater: function (isFlat) {
    return new SchemaAnnotater(isFlat);
  },
};

/* Public Methods */

SchemaAnnotater.prototype.setSchemaDescription = function (description) {
  this._annotateObject(this._annotations, null, description);
};

SchemaAnnotater.prototype.setAttributeFormat = function (attribute, format) {
  if (typeof attribute !== 'string') {
    return;
  }
  this._annotateObject(this._getAttributeObject(attribute), format);
};

SchemaAnnotater.prototype.setAttributeIsPii = function (attribute, isPii) {
  if (typeof attribute !== 'string') {
    return;
  }
  this._annotateObject(this._getAttributeObject(attribute), null, null, isPii);
};

SchemaAnnotater.prototype.setAttributeDescription = function (attribute, description) {
  if (typeof attribute !== 'string') {
    return;
  }
  this._annotateObject(this._getAttributeObject(attribute), null, description);
};

SchemaAnnotater.prototype.getJson = function () {
  return JSON.stringify(this._annotations);
};

SchemaAnnotater.prototype.getObject = function () {
  return this._annotations;
};

/* Pseudo-private Methods */

SchemaAnnotater.prototype._getAttributeObject = function (attribute) {
  if (this._isFlat) {
    if (attribute.length === 0) {
      return this._annotations;
    }
    this._annotations.properties[attribute] = this._annotations.properties[attribute] || {};
    return this._annotations.properties[attribute];
  }

  var pathParts = attribute.split('.');
  var curObj = this._annotations;

  while (pathParts.length > 0) {
    var pathPart = pathParts.shift();
    if (pathPart.length === 0) {
      break;
    }

    if (!curObj.properties) {
      curObj.properties = {};
    }

    if (!curObj.properties[pathPart]) {
      curObj.properties[pathPart] = {};
    }

    curObj = curObj.properties[pathPart];
  }

  return curObj;
};

SchemaAnnotater.prototype._annotateObject = function (obj, format, description, isPii) {
  if (!obj) {
    return;
  }
  if (typeof format === 'string') {
    obj['format'] = format;
  }

  if (typeof description === 'string') {
    obj['description'] = description;
  }

  if (typeof isPii === 'boolean') {
    obj['isPii'] = isPii;
  }
};
